import { getPreferredLanguage } from 'pricing-pages-lib/utils/getPreferredLanguage';
export const getBrowserLocale = () => {
  const browserLocale = getPreferredLanguage().toLowerCase() || 'en-us';
  const preferredCountryCode = window.COUNTRY_CODE_FROM_LOCALE && window.COUNTRY_CODE_FROM_LOCALE.toUpperCase();
  return {
    browserLocale,
    preferredCountryCode
  };
};